import './styles/file-section.css'
import DragAndDrop from './DragAndDrop'

export default function FileSection() {

  return (
    <div className='file-section'>
      <div className="container">
        <div className='file-section__head'>
            <div className='file-section__title'>
                Some title for this section
            </div>
            <div className='file-section__info'>
            Lorem ipsum dolor sit amet consectetur adipiscing elit 
            Ut et massa mi. Aliquam in hendrerit. ectetur adipiscing 
            elit Ut et massa mi. Aliquam in hendrerit.
            </div>
        </div>
        <div className='file-section__input'>
            <DragAndDrop/>
        </div>
      </div>
    </div>
  )
}
